import {Header} from "../components/Header";
import {BoxAndImage} from "../components/BoxAndImage";

const DemoPage = () => {
    return (
        <>
            <Header/>
            <BoxAndImage/>
        </>
    )
}

export default DemoPage;